import { isBridgeAvailable } from './firebaseBridge.js';
import { GA4Forwarder } from './GA4Forwarder.js';
import { FirebaseWebviewForwarder } from './FirebaseWebviewForwarder.js';

// Boot at module load — index.hbs lädt das Script im <head>, kein Custom Element nötig.
// In der App-Webview übernimmt das Firebase-SDK der App den Versand, im Webshop gtag.
if (isBridgeAvailable()) {
    FirebaseWebviewForwarder.initOnce();
} else {
    GA4Forwarder.initOnce();
}
